import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated } from './apollo/client';

import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DirectoryPage from './pages/DirectoryPage';
import PersonDetailPage from './pages/PersonDetailPage';
import TreePage from './pages/TreePage';
import BirthdaysPage from './pages/BirthdaysPage';
import MessageBoardPage from './pages/MessageBoardPage';

// Protected route wrapper
function ProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/directory" replace />} />
        <Route path="directory" element={<DirectoryPage />} />
        <Route path="person/:id" element={<PersonDetailPage />} />
        <Route path="tree" element={<TreePage />} />
        <Route path="birthdays" element={<BirthdaysPage />} />
        <Route path="message-board" element={<MessageBoardPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;

